module.exports = __webpack_public_path__ + "a83c6d4e3d16316efbef70b903885059.svg";